export enum RedisDbs {
  Development = 10,
  QA = 11,
  Production = 12,
  Development2 = 13,
  QA2 = 14,
}
